// extracted by mini-css-extract-plugin
export default {"container":"gi-z","bubbleNav":"hi-z","graphic":"ii-z","contact":"ji-z"};